import { styled } from '@mui/material/styles'
import MuiSummary, {
  accordionSummaryClasses,
} from '@mui/material/AccordionSummary'

const Summary = styled(MuiSummary)({
  // disable grow on expand
  [`&.${accordionSummaryClasses.expanded}`]: { minHeight: '48px' },
  [`& .${accordionSummaryClasses.content}`]: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    fontSize: '14px',
    fontWeight: 500,
    [`&.${accordionSummaryClasses.expanded}`]: { margin: 'unset' },
  },
  expanded: {},
})

export default Summary
